import adminGrupoService from '../../services/admin/AdminGrupoService'

// Requisição em voo, fora do state pelo mesmo motivo do AdminUserStore: a
// listagem de grupos e o formulário de usuário podem montar quase juntos.
let gruposRequest = null

export const adminGrupoModule = {
  namespaced: true,
  state: {
    // `{ id, nome, precio, membros_count }` — poucos registros, lista inteira.
    grupos: [],
    gruposLoaded: false,
    loading: false,
    saving: false,
  },
  mutations: {
    SET_GRUPOS(state, payload) {
      state.grupos = payload
      state.gruposLoaded = true
    },
    // Criar, renomear, excluir — e salvar um usuário, que muda a contagem de
    // membros — deixam a lista memoizada velha.
    INVALIDATE_GRUPOS(state) {
      state.gruposLoaded = false
      gruposRequest = null
    },
    // Um grupo recém-criado entra na lista que a tela já tem, na ordem do
    // backend (por nome), sem nova requisição (#74). A lista continua marcada
    // como velha: a próxima leitura sem `force` ainda vai ao servidor.
    ADD_GRUPO(state, grupo) {
      state.grupos = [...state.grupos, grupo].sort((a, b) =>
        String(a.nome).localeCompare(String(b.nome))
      )
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_SAVING(state, saving) {
      state.saving = saving
    },
  },
  actions: {
    async fetchGrupos({ commit, state }, { force = false } = {}) {
      if (state.gruposLoaded && !force) return state.grupos
      if (gruposRequest && !force) return gruposRequest

      commit('SET_LOADING', true)
      gruposRequest = adminGrupoService
        .getGrupos()
        .then((response) => {
          const grupos = (response && response.data) || []
          commit('SET_GRUPOS', grupos)
          return grupos
        })
        .finally(() => {
          gruposRequest = null
          commit('SET_LOADING', false)
        })

      return gruposRequest
    },
    invalidateGrupos({ commit }) {
      commit('INVALIDATE_GRUPOS')
    },
    async fetchGrupo(context, id) {
      return await adminGrupoService.getGrupo(id)
    },
    async createGrupo({ commit }, payload) {
      commit('SET_SAVING', true)
      try {
        const data = await adminGrupoService.createGrupo(payload)
        commit('INVALIDATE_GRUPOS')
        return data
      } finally {
        commit('SET_SAVING', false)
      }
    },
    // Criação rápida do formulário de usuário (#74): só o nome, então o grupo
    // nasce conhecido por inteiro — sem preços e sem membros.
    async createGrupoRapido({ commit }, nome) {
      commit('SET_SAVING', true)
      try {
        const data = await adminGrupoService.createGrupo({ nome })
        commit('INVALIDATE_GRUPOS')
        const grupo = data.grupo
        commit('ADD_GRUPO', {
          id: grupo.id,
          nome: grupo.nome,
          precio: null,
          membros_count: 0,
        })
        return grupo
      } finally {
        commit('SET_SAVING', false)
      }
    },
    async updateGrupo({ commit }, { payload, id }) {
      commit('SET_SAVING', true)
      try {
        const data = await adminGrupoService.updateGrupo(payload, id)
        commit('INVALIDATE_GRUPOS')
        return data
      } finally {
        commit('SET_SAVING', false)
      }
    },
    async deleteGrupo({ commit }, { id, moverPara = null }) {
      commit('SET_SAVING', true)
      try {
        const data = await adminGrupoService.deleteGrupo(id, moverPara)
        commit('INVALIDATE_GRUPOS')
        return data
      } finally {
        commit('SET_SAVING', false)
      }
    },
    // O que um grupo concede, para o herdado ao vivo do formulário de usuário
    // (#64). Sem memoização aqui: quem chama guarda por id.
    async fetchPermissions(context, id) {
      return await adminGrupoService.getPermissions(id)
    },
  },
  getters: {
    grupos: (state) => state.grupos,
    loading: (state) => state.loading,
    saving: (state) => state.saving,
  },
}
